import { makeAutoObservable, toJS } from "mobx";
import AppStore from "../stores/AppStore";

// Define the Qualification interface
export interface ITrainingRequest {
    id: string;
    uid: string;
    courseName: string; // Name of the course
    startDate: number; // Start date of the course
    endDate: number; // End date of the course
    certificateObtained: string; // Name of the certificate obtained
    institution: string; // Institution where the course was completed
    comments: string; // Additional comments or notes
    name: string;
    email: string;
    department: string;
    phoneNumber: string;
   
    location: string;
    supervisor: string;
    fax: string;
    supervisorPhone: string;
   
    preferredDate: number;
    offeredBy: string;
    courseLocation: string;
    courseSummary: string;
    requestType:IType
    duration:string;
    purpose:string;
    dateRequested:number;
    confirmation:boolean;
    status:ITrainingStatus;
    trainingType:ITrainingType 
    budget:number
    attachment:string[];
}

// Default Qualification object to use for initializing state
export const defaultTrainingRequest: ITrainingRequest = {
    id: "",
    uid: "",
    courseName: "",
    startDate: 0,
    endDate: 0,
    certificateObtained: "",
    institution: "",
    comments: "",
    name: "",
    email: "",
    department: "",
    phoneNumber: "",

    location: "",

    fax: "",
    supervisorPhone: "",
    preferredDate: 0,
    offeredBy: "",
    courseLocation: "",
    courseSummary: "",
    supervisor: "",
    requestType: "Employee",
    duration: "",
    purpose: "",
    confirmation: false,
    dateRequested: 0,
    status: "Pending",
    trainingType: "Requested from Employee",
    budget: 0,
    attachment: []
};

export type IType ="Employee"|"Admin" ;
export type ITrainingType = "Requested from Employee"|"External"|"Internal";
export type ITrainingStatus = "Approved"|"Pending"|"Completed";
export default class TrainingRequest {
    private trainingRequest: ITrainingRequest;

    constructor(private store: AppStore, trainingRequest: ITrainingRequest) {
        makeAutoObservable(this);
        this.trainingRequest = trainingRequest;
    }

    get asJson(): ITrainingRequest {
        return toJS(this.trainingRequest);
    }

    // Method to update course name
    updateCourseName(name: string) {
        this.trainingRequest.courseName = name;
    }

    // Method to update start date
    updateStartDate(date: number) {
        this.trainingRequest.startDate = date;
    }

    // Method to update end date
    updateEndDate(date: number) {
        this.trainingRequest.endDate = date;
    }

    // Method to update certificate obtained
    updateCertificateObtained(certificate: string) {
        this.trainingRequest.certificateObtained = certificate;
    }

    // Method to update institution
    updateInstitution(institution: string) {
        this.trainingRequest.institution = institution;
    }

    // Method to update comments
    updateComments(comments: string) {
        this.trainingRequest.comments = comments;
    }

    // Additional methods can be implemented as needed
}
